/** 숫자를 한국어 화면,보고서용으로 , 유효숫자 기준, 천 단위 구분 */
export function fmt(n: number | null | undefined, digits = 2): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "없음";
  const abs = Math.abs(n);
  const d = abs >= 1000 ? 0 : abs >= 100 ? 1 : abs >= 1 ? digits : 3;
  return n.toLocaleString("ko-KR", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function pct(n: number, digits = 1): string {
  return `${(n * 100).toLocaleString("ko-KR", { minimumFractionDigits: digits, maximumFractionDigits: digits })}%`;
}
